import { IdentifiableItemResponse } from './Common'
import SocialNetwork from './SocialNetwork'

export enum PublishFrequency {
    ONCE = 'ONCE',
    DAILY = 'DAILY',
    WEEKLY = 'WEEKLY',
    MONTHLY = 'MONTHLY'
}

export enum PostType {
    POST = 'POST',
    STORY = 'STORY',
    REEL = 'REEL'
}

export enum PostApprovalStatusType {
    // Where every post starts, until the client approves it
    NEW = 'NEW',
    APPROVED = 'APPROVED',
    CHANGE_REQUIRED = 'CHANGE_REQUIRED',
    DECLINED = 'DECLINED'
}

export enum PostStatusType {
    PUBLISHED = 'PUBLISHED',
    NOT_PUBLISHED = 'NOT_PUBLISHED',
    SCHEDULED = 'SCHEDULED'
}

type PostDTO = {
    id?: number
    title: string
    clientFirstName: string
    clientLastName: string
    description: string
    hashTags: string
    clientId: number
    socialNetwork: SocialNetwork
    postType: PostType
    postApprovalStatus: PostApprovalStatusType
    postStatus: PostStatusType
    publishFrom: string
    publishUntil: string
    publishAt: string
    photo: string
    showInCalendar: boolean
    publishFrequency: PublishFrequency
    linkedinAuthorUrn: string
    metaPageId: string
    tiktokPrivacyLevel: string
    tiktokAllowComment: boolean
    tiktokAllowDuet: boolean
    tiktokAllowStitch: boolean
    tiktokCommercialContent: boolean
    tiktokBrandOrganic: boolean
    tiktokBrandedContent: boolean
} & IdentifiableItemResponse

export type TiktokCreatorInfo = {
    available: boolean
    errorCode?: string | null
    creatorNickname?: string | null
    creatorUsername?: string | null
    creatorAvatarUrl?: string | null
    privacyLevelOptions: string[]
    commentDisabled: boolean
    duetDisabled: boolean
    stitchDisabled: boolean
    maxVideoPostDurationSec?: number | null
}

export interface PostFormData extends Omit<PostDTO, 'hashTags' | 'publishFrom' | 'publishUntil' | 'publishAt' | 'clientId' | 'id' | 'clientFirstName' | 'clientLastName'> {
    hashTags: string[],
    publishAt: string,
    clientId: string,
    publishFrom: Date | null,
    publishUntil: Date | null
}

export interface PostsFilter {
    clientId: string | null,
    // Shows the posts hidden by hand or a week after they were published, instead of the rest
    hidden: boolean,
}


export default PostDTO